import { isColumnHidden } from './columnVisibility';

// Fields the form shows (enabled, mapped, not hidden) must be filled before recording:
// a volume measurement and its temperature when draining, the volume temperature when
// full, the ABV and its temperature, and the diameters.
export const validateFieldsAtSubmit = async (
  values,
  columnMappings,
  fillingStatus,
  containerType,
  globalActions,
  t,
) => {
  const errors = [];

  // Check if container is empty - no validation needed
  if (fillingStatus === 'empty') {
    return true;
  }

  const shown = (fieldName) => !isColumnHidden(columnMappings, fieldName);
  const missing = (fieldName, valueKey) => shown(fieldName) && !values[valueKey]?.value;

  if (fillingStatus === 'full') {
    if (missing('volumeTemperature', 'volumeTemp')) {
      errors.push(t('validation.volume_temperature_required_for_full_container'));
    }
  } else {
    const measurements = ['liquidHeight', 'emptyHeight', 'liquidVolume'].filter(shown);
    if (measurements.length > 0 && !measurements.some((fieldName) => values[fieldName]?.value)) {
      errors.push(t('validation.volume_measurement_required_for_partial_container'));
    }
    if (missing('volumeTemperature', 'volumeTemp')) {
      errors.push(t('validation.volume_temperature_required_for_partial_container'));
    }
  }

  if (missing('tav', 'tav')) {
    errors.push(t('validation.tav_required'));
  }
  if (missing('tavTemperature', 'tavTemp')) {
    errors.push(t('validation.tav_temperature_required'));
  }

  if (missing('internalDiameterDown', 'diameterDown')) {
    errors.push(t('validation.diameter_down_required_for_truncated_cone'));
  }
  if (missing('internalDiameterUp', 'diameterUp')) {
    errors.push(t('validation.diameter_up_required_for_truncated_cone'));
  }

  if (errors.length > 0) {
    globalActions.setSnackbarMessage({
      message: errors.join('\n'),
      severity: 'warning',
    });
    return false;
  }

  return true;
};
